import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { PageSlice } from '@contracts';
import Text from './Text';

interface Props {
  slice: PageSlice;
}

const TwoColumnGrid: React.FC<Props> = ({ slice }) => {
  const rows = slice.items;
  const color1 = slice.primary?.background_color_1;
  const color2 = slice.primary?.background_color_2;

  return (
    <Container $border={slice.primary?.border?.text}>
      {rows &&
        rows.map((row, index) => {
          const leftIcon = getImage(row.left_icon);
          const rightIcon = getImage(row.right_icon);
          return (
            <Row key={index} $backgroundColor={index % 2 === 0 ? color1 : color2}>
              <Side>
                <GatsbyImage image={leftIcon} alt="" objectFit="contain" />
                <Text richText={row.left_text.richText} />
              </Side>
              <Side>
                <GatsbyImage image={rightIcon} alt="" objectFit="contain" />
                <Text richText={row.right_text.richText} />
              </Side>
            </Row>
          );
        })}
    </Container>
  );
};

export default TwoColumnGrid;

interface StyleProps {
  $border?: string;
  $backgroundColor?: string;
}

const Container = styled.div<StyleProps>`
  ${(props) => `border: ${props.$border || 'none'}`};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Row = styled.div<StyleProps>`
  ${(props) => `background: ${props.$backgroundColor || 'none'}`};
  display: flex;
  width: 100%;
  align-items: start;
  justify-content: space-around;
  padding: 15px 75px;
  gap: 92px;

  @media (max-width: 768px) {
    gap: 33px;
  }
`;

const Side = styled.div`
  font-family: BrownStd;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: left;

  display: flex;
  gap: 20px;
  min-width: 145px;

  @media (max-width: 768px) {
    section {
      padding: 0;
    }
  }
`;
